<template>
    <playerList :type="'coach'"></playerList>
</template>

<script>
    import playerList from "../components/newPlayerList";
    export default {
        name: "coachList",
        components:{
            playerList
        }
    }
</script>

<style scoped>

</style>
